<h1 mat-dialog-title>New Log</h1>
<form [formGroup]="form">
  <div mat-dialog-content>
    <div layout="column">
      <mat-form-field flex>
        <input matInput placeholder="Dispatch ID" formControlName="dispatchId" />
      </mat-form-field>
      <td-message
        *ngIf="flightNotFound"
        sublabel="The flight could not be found."
        class="bgc-light-blue-200"
        icon="info"
      ></td-message>
      <ng-container *ngIf="hasFlightLogData">
        <td-message
          sublabel="This flight has already been logged."
          class="bgc-light-blue-200"
          icon="info"
        ></td-message>
        <table mat-table [dataSource]="searchResults?.data">
          <ng-container matColumnDef="dateOfService">
            <th mat-header-cell *matHeaderCellDef>Date of Service</th>
            <td mat-cell *matCellDef="let fl">
              <span title="{{ fl.dateOfService | date : 'full' || 'Unknown' }}">
                {{ (fl.dateOfService | date : 'MM/dd/yyyy HH:mm') || '--' }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="flightType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let fl">
              {{ fl.flightType }}
            </td>
          </ng-container>
          <ng-container matColumnDef="aircraftTailNumber">
            <th mat-header-cell *matHeaderCellDef>Tail Number</th>
            <td mat-cell *matCellDef="let fl">
              {{ fl.aircraftTailNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Log Status</th>
            <td mat-cell *matCellDef="let fl">
              {{ fl.status }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onCreate()"
      [disabled]="form.invalid || submitting"
      *ngIf="!hasFlightLogData"
    >
      Create Log
    </button>
    <button mat-button (click)="onAddNewLog()" *ngIf="hasFlightLogData" [disabled]="submitting">
      Add New Log
    </button>
    <button mat-button (click)="onCancel()">Cancel</button>
    <!--
      <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
    -->
  </div>
</form>
